import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"],
  _excluded2 = ["children"];
import { Flex } from 'foundations-components/components/Flex';
import { Link as FoundationsLink } from 'foundations-components/transitional/components/Link';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { ExternalLinkIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getTrainingAndServicesLink from '../utils/getTrainingAndServicesLink';
import { View } from 'foundations-components/components/View';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExternalLinkWithIcon = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "row",
    children: [/*#__PURE__*/_jsx(FoundationsLink, Object.assign({}, props, {
      target: "_blank",
      children: /*#__PURE__*/_jsx(Text, {
        paddingBlock: "200",
        typography: "heading-50",
        children: children
      })
    })), /*#__PURE__*/_jsx(IconHolder, {
      "aria-label": "Opens in new tab",
      color: "icon-core-default",
      icon: ExternalLinkIcon,
      paddingBlock: "0",
      paddingInline: "100",
      size: "400"
    })]
  });
};
const Link = _ref2 => {
  let {
      children
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(FoundationsLink, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(Text, {
      paddingBlock: "200",
      typography: "heading-50",
      children: children
    })
  }));
};
export const FaceNavAccountLinks = ({
  baseAppUrl,
  hasProjectAccess = false,
  isDevPortal = false,
  portalId,
  homepageUrl,
  academyStudioUrl
}) => {
  return /*#__PURE__*/_jsx(View, {
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    borderColor: "border-core-default",
    paddingBlock: "200",
    paddingInline: "400",
    children: /*#__PURE__*/_jsxs(List, {
      children: [isDevPortal ? /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Link, {
          color: "text-core-default",
          href: `${baseAppUrl}/developer/${portalId}/account/`,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.accounts"
          })
        })
      }) : /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Link, {
          color: "text-core-default",
          href: `${baseAppUrl}/account-dashboard/${portalId}/`,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.accountAndBilling"
          })
        })
      }), homepageUrl && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(ExternalLinkWithIcon, {
          href: homepageUrl,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.hubSpotSoftware"
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Link, {
          href: `${baseAppUrl}/pricing/${portalId}?upgradeSource=nav-dropdown`,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.pricingAndFeatures"
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Link, {
          href: `${baseAppUrl}/product-updates/${portalId}`,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.productUpdates"
          })
        })
      }), hasProjectAccess && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Link, {
          href: `${baseAppUrl}/projects/${portalId}`,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.projects"
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(ExternalLinkWithIcon, {
          href: getTrainingAndServicesLink(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.faceNav.trainingAndServices"
          })
        })
      }), academyStudioUrl && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(ExternalLinkWithIcon, {
          href: academyStudioUrl,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyNav.academyStudio"
          })
        })
      })]
    })
  });
};